/* eslint-disable no-nested-ternary */
import React, { useState, useCallback } from "react";
import { Box } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import ListContainerChats from "src/components/pages/dashboard/ListContainerChats";
import Header from "./header";
import useStyles from "./Styles";

const PagesBreakDownList = () => {
  const { classes } = useStyles();

  const [selectedChannel, setSelectedChannel] = useState("facebook");

  const handleChangeChannel = (event: SelectChangeEvent) => {
    setSelectedChannel(event.target.value as string);
  };

  const renderChatList = useCallback(() => {
    switch (selectedChannel) {
      case "facebook":
        return (
          <ListContainerChats
            title="Facebook Pages Breakdown"
            source="facebook"
          />
        );
      case "whatsapp":
        return (
          <ListContainerChats
            title="Whatsapp Numbers Breakdown"
            source="whatsapp"
          />
        );
      case "chatbot":
        return (
          <ListContainerChats
            title="Chatbot Widgets Breakdown"
            source="chatbot"
          />
        );
      case "instagram":
      default:
        return (
          <ListContainerChats title="Instagram Breakdown" source="instagram" />
        );
    }
  }, [selectedChannel]);

  return (
    <Box className={classes.root}>
      <Header
        selectedChannel={selectedChannel}
        handleChangeChannel={handleChangeChannel}
      />
      <Box className={classes.listBox}>{renderChatList()}</Box>
    </Box>
  );
};

export default PagesBreakDownList;
